// Generated by purs version 0.15.15
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_EditAsString from "../Restaumatic.Form.EditAsString/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var compare = /* #__PURE__ */ Data_Ord.compare(Data_Ord.ordString);
var VatIdIsSymbol = {
    reflectSymbol: function () {
        return "VatId";
    }
};
var VatId = function (x) {
    return x;
};
var toFillFormTypeVatId = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeVatId_ = {
    Coercible0: function () {
        return undefined;
    }
};
var eqVatId = {
    eq: function (x) {
        return function (y) {
            return x === y;
        };
    }
};
var ordVatId = {
    compare: function (x) {
        return function (y) {
            return compare(x)(y);
        };
    },
    Eq0: function () {
        return eqVatId;
    }
};
var editAsStringVatId = Restaumatic_Form_EditAsString.editAsStringString;
var genericVatId = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showVatId = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericVatId)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))(VatIdIsSymbol))
};
var unscrambleDecodeVatId = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericVatId)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(Unscramble.decodeString1)))(Unscramble_Generic.defaultOptions)
};
var encodeVatId = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericVatId)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(VatIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))
};
var decodeVatId = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericVatId)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(VatIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode)))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    VatId,
    editAsStringVatId,
    ordVatId,
    genericVatId,
    eqVatId,
    showVatId,
    encodeVatId,
    decodeVatId,
    unscrambleDecodeVatId,
    toFillFormTypeVatId,
    newtypeVatId_
};
